module.exports = __webpack_public_path__ + "media/images/table-e6dd474adde878bd6f280929efe8fc96.svg";